/* istanbul ignore file */
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestCurrentInitialBuildIdsSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_CURRENT_INITIAL_BUILD_IDS'),
    ],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(codecString)),
    ],
]);
export class NewAutoTestCurrentInitialBuildIdsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestCurrentInitialBuildIdsSettingParser.decode(input).map(res => new NewAutoTestCurrentInitialBuildIdsSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestCurrentInitialBuildIdsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestCurrentInitialBuildIdsSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestCurrentInitialBuildIdsSettingParser.schema();
    }
}
